import React, { useEffect, useState } from 'react'
// import CryptoJS from 'crypto-js'
import { Tabs, Input } from '@mantine/core'
import { showNotification } from '@mantine/notifications'
import { useInterval } from '@mantine/hooks'
import { Modal, Button, Toast } from '@ow/comps'
import { useAppEx, useUser } from '@vt/hooks'
import QRCode from 'qrcode.react'
import { getQuery } from '@vt/utils'
import { editUser } from '@vt/apis/lib-ex/v2/users'
import {
  roleList,
  orgNameList,
  getFaceRecognitionState,
  getFaceAuth,
  encryptStr,
  decryptStr,
} from './utils'
import dygcappImg from './dygcapp.png'

const FaceRecognition = function ({ afterFaceRecognition }) {
  const { userInfoInApp, appId, appConfigMutate } = useAppEx()
  // 当前用户是否需求人脸识别
  const [isUserRoleNeedRecognition, setIsUserRoleNeedRecognition] =
    useState(false)
  /** 需要重新校验 */
  const [needReValidate, setNeedReValidate] = useState(true)
  const [isUserIdentifyValid, setIsUserIdentifyValid] = useState(false)
  const [uniqueIdInput, setUniqueIdInput] = useState(null)
  const { logOut } = useUser()
  const { tpl } = getQuery()
  const [inWhite, setInWhite] = useState()
  // const { getVtProject } = useProjectStore()
  // const vtProject = getVtProject()

  console.log('当前用户信息：', userInfoInApp)

  // 当前用户是否需要人脸识别
  const checkIsNeedRecognition = async () => {
    const currentRole = userInfoInApp.roleSlug
    // 是否强制实名
    if (userInfoInApp.forceRealName) {
      // 检查员、管理员、审核员需要人脸校验
      if (roleList.includes(currentRole)) {
        // 海淀的项目
        if (appId === 1015 || appId === 1073) {
          setIsUserRoleNeedRecognition(
            orgNameList.includes(userInfoInApp.orgName)
          )
          // 如果需要人脸识别，就开始验证一下信息是否完善
          if (orgNameList.includes(userInfoInApp.orgName)) {
            checkFullInfo(1)
          }
        } else {
          setIsUserRoleNeedRecognition(true)
          // 如果需要人脸识别，就开始验证一下信息是否完善

          checkFullInfo(2)
        }
      } else {
        // 放行
        setIsUserRoleNeedRecognition(false)
      }
    } else {
      // 放行
      setIsUserRoleNeedRecognition(false)
    }
  }

  // 获取上次人脸校验时间并与当前时间做对比
  const checkRecognitionTime = () => {
    // const lastRecognitionTime = vtProject.getStorage(
    //   `${appId}_${userInfoInApp.userId}_lastRecognitionTime`
    // )

    const lastRecognitionTime = localStorage.getItem(
      `${appId}_${userInfoInApp.userId}_lastRecognitionTime`
    )

    console.log(lastRecognitionTime, '上次校验时间')

    if (lastRecognitionTime) {
      const currentTime = new Date().getTime()
      // 当前人脸识别验证记录时间是否【≤1小时】,大于则弹框重新人脸识别
      if (currentTime - lastRecognitionTime > 3600000 * 4) {
        // 需要再次校验
        setNeedReValidate(true)
        interval.start()
      } else {
        // 不需要再次校验了
        setNeedReValidate(false)
      }
    } else {
      // 需要再次校验
      setNeedReValidate(true)
      interval.start()
    }
  }

  const updateUserInfo = () => {
    // 调接口更新用户信息
    if (uniqueIdInput) {
      if (!/^\d{17}[0-9Xx]$/.test(uniqueIdInput)) {
        Toast.error({ title: '请输入有效身份证号码' })
      } else {
        editUser(appId, {
          id: userInfoInApp.id,
          uniqueId: encryptStr(uniqueIdInput),
        }).then(() => {
          // appConfigMutate()

          Toast.success({ title: '确认完毕，请您重新登录' })

          setTimeout(() => {
            logOut(tpl)
          }, 3000)
        })
      }
    }
  }

  const checkFullInfo = async (num) => {
    if (userInfoInApp.uniqueId) {
      // 信息完整
      // 人脸识别信息判断
      // setIsUserIdentifyValid(true)
      // // 最后判断一下是否需要人脸识别
      // checkRecognitionTime()

      // 最后一步判断
      // 白名单判断
      const res = await getFaceAuth(userInfoInApp.uniqueId, {
        // params: { indentNo: userInfoInApp.uniqueId },
        ignoreAuthorization: true,
      })
      setIsUserIdentifyValid(true)
      // checkRecognitionTime()
      if (res.data?.needFaceAuth === false) {
        setInWhite(true)
      } else {
        // 必须人脸
        setInWhite(false)
        checkRecognitionTime()
      }
    } else {
      // 需要弹框补充信息
      setIsUserIdentifyValid(false)
    }
  }

  const fetchFaceRegnition = async () => {
    const res = await getFaceRecognitionState(
      decryptStr(userInfoInApp.uniqueId),
      {
        // params: { indentNo: userInfoInApp.uniqueId },
        ignoreAuthorization: true,
      }
    )

    console.log('上次的人脸识别信息=>', res)
    if (res.data) {
      if (res.data.updateTime) {
        // 无论是否成功，都更新 storage 存储的时间
        // onValidDone(res.data.data.updateTime)
        const updateTime = new Date(res.data.updateTime).getTime()

        const currentTime = new Date().getTime()

        // vtProject.setStorage(
        //   `${appId}_${userInfoInApp.userId}_lastRecognitionTime`,
        //   updateTime
        // )

        localStorage.setItem(
          `${appId}_${userInfoInApp.userId}_lastRecognitionTime`,
          updateTime
        )
        // 当前人脸识别验证记录时间是否【≤1小时】,则说明已进行了人脸识别
        if (currentTime - updateTime <= 3600000 * 4) {
          // 关闭弹框校验，走流程

          // vtProject.setStorage(
          //   `${appId}_${userInfoInApp.userId}_lastRecognitionTime`,
          //   updateTime
          // )

          Toast.success({ title: '您已完成人脸识别' })

          interval.stop()
          // 此时需要关闭弹框
          if (afterFaceRecognition) {
            afterFaceRecognition()
          }
          setNeedReValidate(false)
        } else {
          // needReValidate.value = true
        }
      } else {
        //
      }
    } else {
      //
    }
  }

  const interval = useInterval(() => fetchFaceRegnition(), 5000)

  useEffect(() => {
    // 判断当前用户需不需要人脸识别
    checkIsNeedRecognition()
  }, [userInfoInApp])

  // useEffect(() => {
  //   // 弹框了，这个时候轮询判断有没有校验完毕
  //   if (isUserIdentifyValid && needReValidate) {
  //   }
  // }, [isUserIdentifyValid, needReValidate])

  // 需要人脸识别但信息不完整
  if (!isUserIdentifyValid && isUserRoleNeedRecognition && inWhite === false) {
    return (
      <Modal
        closeOnDocumentClick={false}
        contentStyle={{ height: '80vh', width: '60vw' }}
        maxHeight="80vh"
        open
      >
        <div class="w-full flex flex-col gap-4">
          <p>为确保信息安全，需确认您的身份(请务必准确填写)</p>
          <Input
            style={{ width: '100%' }}
            placeholder="请输入您的身份证号码"
            onChange={(e) => {
              const { value } = e.target

              setUniqueIdInput(value)
            }}
          />
          <Button type="primary" onClick={updateUserInfo} className="w-[100px]">
            确定
          </Button>
        </div>
      </Modal>
    )
  }
  // 如果信息完整且当前人脸识别验证记录时间是否【≤1小时】,大于则弹框重新人脸识别
  if (isUserIdentifyValid && needReValidate && inWhite === false) {
    return (
      <Modal
        closeOnDocumentClick={false}
        contentStyle={{ height: '80vh', width: '60vw' }}
        maxHeight="80vh"
        open
      >
        <Tabs defaultValue="face">
          <Tabs.List>
            <Tabs.Tab value="face">人脸识别验证</Tabs.Tab>
            <Tabs.Tab value="app">下载调研工厂调查员版App</Tabs.Tab>
          </Tabs.List>
          <Tabs.Panel value="face" pt="xs">
            <div class="flex justify-center text-center flex-col mt-4">
              <p>为确保信息安全，需确认您的身份</p>
              <p> 请使用“调研工厂调查员版”App</p>
              <p>扫描下方二维码进行人脸识别验证</p>
              <div class="p-4 flex justify-center items-center display-block">
                <QRCode
                  value={`http/survey?idNum=${userInfoInApp.uniqueId}`}
                  size={250}
                />
              </div>
            </div>
          </Tabs.Panel>
          <Tabs.Panel value="app" pt="xs">
            <div class="flex justify-center text-center mt-4 flex-col">
              <p>请使用手机扫描下方二维码，下载“调研工厂调查员版”App</p>
              <p>完成App下载后，使用您当前的账号进行登录</p>
              <p> 使用App扫码功能扫描“人脸识别验证”中的二维码进行验证</p>
            </div>
            <div class="p-4 flex justify-center items-center display-block">
              <img
                src={dygcappImg}
                style={{
                  width: '250px',
                  height: '250px',
                  marginBottom: '6px',
                }}
                alt=""
              />
            </div>
          </Tabs.Panel>
        </Tabs>
      </Modal>
    )
  }
  return null
}

export default FaceRecognition
